module.exports = {"441403001":"新城","441403101":"城东镇","441403102":"石扇镇","441403103":"梅西镇","441403104":"大坪镇","441403105":"石坑镇","441403109":"水车镇","441403110":"梅南镇","441403113":"丙村镇","441403115":"白渡镇","441403116":"松源镇","441403117":"隆文镇","441403118":"桃尧镇","441403126":"畲江镇","441403129":"雁洋镇","441403130":"松口镇","441403131":"南口镇","441403132":"程江镇","441403133":"扶大镇","441403500":"梅西水库"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441403.json
// module id = 2025
// module chunks = 0